export function escapeString(text: string): string {
  return text.replace(/[\\"']/g, (match) => "\\" + match);
}
